import { z } from "zod";
import { defineEvent } from "./registry.js";
/**
 * Yerel kasa (POS) olayları (Prompt 15).
 *
 * Yük KİŞİSEL VERİ TAŞIMAZ: plaka, müşteri telefonu, personel adı ve barkod yoktur (KVKK, AGENTS.md §3.14).
 * Kimlikler taşınır; adı isteyen istemci `pos.read` yetkili okuma ucundan çeker.
 *
 * `pos.sale.recorded` PARTİ ÖZETİ DEĞİL, SATIŞ BAŞINA üretilir: istasyon panosu ve kasa raporları canlı
 * güncellensin. Hacim kabul edilebilir (istasyon başına günde birkaç yüz fiş; akaryakıt işlemi gibi binlerce
 * değil) ve oda `station`'dır — kiracı genelinde yayılmaz.
 */
export const posSaleRecordedV1 = defineEvent({
    type: "pos.sale.recorded",
    version: 1,
    description: "Yerel kasadan satış / iade kaydı bulut defterine yazıldı",
    realtime: ["station"],
    payload: z.object({
        saleId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        agentId: z.uuid().nullable(),
        agentSaleId: z.string(),
        businessDate: z.iso.date(),
        occurredAt: z.iso.datetime({ offset: true }),
        shiftId: z.uuid().nullable(),
        staffId: z.uuid().nullable(),
        kind: z.enum(["SALE", "RETURN"]),
        lineCount: z.number().int().nonnegative(),
        gross: z.string().describe("KDV dâhil (kuruş)"),
        discountTotal: z.string(),
        net: z.string(),
        vatTotal: z.string(),
        tenderTypes: z.array(z.string()),
        hasReceipt: z.boolean(),
        warnings: z.array(z.string()),
    }),
});
export const posSaleVoidedV1 = defineEvent({
    type: "pos.sale.voided",
    version: 1,
    description: "Kasa satışı iptal edildi ya da (kısmen) iade edildi",
    realtime: ["station"],
    payload: z.object({
        saleId: z.uuid().describe("İptal edilen satış"),
        voidSaleId: z.uuid().nullable().describe("Ters tutarlı RETURN kaydı; tam iptalde de üretilir"),
        companyId: z.uuid(),
        stationId: z.uuid(),
        businessDate: z.iso.date(),
        partial: z.boolean(),
        amount: z.string().describe("İade edilen net tutar (pozitif, kuruş)"),
        approvedByStaffId: z.uuid().nullable(),
    }),
});
export const posSaleAfterDayLockV1 = defineEvent({
    type: "pos.sale.after_day_lock",
    version: 1,
    description: "Kilitlenmiş iş gününe geç düşen kasa satışı kaydedildi (düzeltme fişi ELLE yazılır)",
    realtime: ["station", "tenant"],
    payload: z.object({
        saleId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        businessDate: z.iso.date(),
        occurredAt: z.iso.datetime({ offset: true }),
        net: z.string(),
    }),
});
export const posCreditLimitExceededOfflineV1 = defineEvent({
    type: "pos.credit_limit_exceeded_offline",
    version: 1,
    description: "Çevrimdışı kesilen veresiye / filo satışı senkronda GERÇEK limiti aştı (satış geri alınmaz; cariye not düşülür)",
    realtime: ["station", "tenant"],
    payload: z.object({
        saleId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        counterpartyId: z.uuid(),
        amount: z.string(),
        verdict: z.string(),
        creditLimit: z.string().nullable(),
        riskAfter: z.string(),
        /** POS satış anında (önbellek limitine göre) aşımı müdür onayıyla geçmiş mi. */
        overriddenAtPos: z.boolean(),
    }),
});
export const posSaleFiscalSkippedV1 = defineEvent({
    type: "pos.sale.fiscal_skipped",
    version: 1,
    description: "Kasa satışı ÖKC fişi olmadan kaydedildi (Z raporuyla fark çıkacaktır)",
    realtime: ["station"],
    payload: z.object({
        saleId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        businessDate: z.iso.date(),
        net: z.string(),
    }),
});
export const posSaleRetenderedV1 = defineEvent({
    type: "pos.sale.retendered",
    version: 1,
    description: "Kasa satışının ödeme türü düzeltildi (akaryakıt satırı iade edilemez; yalnızca ödemesi değişir)",
    realtime: ["station"],
    payload: z.object({
        saleId: z.uuid(),
        companyId: z.uuid(),
        stationId: z.uuid(),
        businessDate: z.iso.date(),
        previousTenderTypes: z.array(z.string()),
        tenderTypes: z.array(z.string()),
        amount: z.string().describe("Satışın net tutarı (kuruş)"),
        approvedByStaffId: z.uuid().nullable(),
    }),
});
//# sourceMappingURL=pos.v1.js.map